<div class="status-box">
  <img
    class="icon"
    src="{{ 'assets/images/dashboard/icone-horloge.svg' | cheminAbsoluStatique }}"
    width="18"
    height="24"
    alt=""
  />
  <span class="text" id="{{ spanId }}" [innerHtml]="textContent"></span>
</div>
